<template>
  <b-table
    hover 
    responsive
    small
    :busy.sync="isBusy"
    :sticky-header="height"
    head-variant="light"
    

    :items="data" 
    :fields="fields"

    :current-page="currentPage"
    :per-page="perPage"

    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :sort-direction="sortDirection"
  >
  <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle d-flex justify-content-start "></b-spinner>
          <strong>Cargando...</strong>
        </div>
  </template>
  <template #head(OF)="scope">
        <div >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Descripcion)="scope">
        <div style="width:500px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(ESTATUS_OF)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(NAI)="scope">
        <div style="width:70px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(ESTATUS_NAI)="scope">
        <div style="width:100px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(NASN)="scope">
        <div style="width:80px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(pedida)="scope">
        <div style="width:80px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Planificada)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Entregado_PT)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Facturada)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Por_Entregar)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Existencia_PT)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Tarimas_del_Pedido)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Peso_Pedido)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Tarimas_en_PT)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Peso_PT)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Cliente)="scope">
        <div style="width:400px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(OC_SN)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Pedido)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Elaboracion_Pedido)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Fecha_OF)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Vencimiento)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Vendedor)="scope">
        <div style="width:250px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Precio_descuento)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Peso_Pieza)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Unidad_de_Carga)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Corrugado)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Pliegos_a_Imprimir)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Planilla)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Suaje)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Tinta_1)="scope">
        <div style="width:250px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Tinta_2)="scope">
        <div style="width:250px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Tinta_3)="scope">
        <div style="width:250px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Tinta_4)="scope">
        <div style="width:250px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Tinta_5)="scope">
        <div style="width:250px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Tinta_6)="scope">
        <div style="width:250px" >
          {{ scope.label }}
        </div>
  </template>
  <template #head(Liberacion_MP)="scope">
        <div style="width:110px" >
          {{ scope.label }}
        </div>
  </template>
  
  <template v-slot:cell(Pliegos_a_Imprimir)="row">
    <div>
      {{ millar(row.item.Pliegos_a_Imprimir)}}
    </div>
  </template>
  <template v-slot:cell(Corrugado)="row">
    <div>
      {{ twoDecimal(row.item.Corrugado)}}
    </div>
  </template>
 
  </b-table>  
</template>

<script>
  import customMixin from '@/mixins/customMixin'
  export default {
    name:'ComponenteTabla',
    mixins : [customMixin],
    props: {
      data:{
        type: Array,
        required: true
      },
      fields:{
        type: Array,
        required:true
      },
      height: {
        type: String,
        default: '60vh'
      },
      perPage:{
        type: Number,
       
      },
      currentPage:{
        type: Number,
        
      },
      isBusy:{
        type: Boolean,
        Default: false
      }
    },
	  data: function(){
      return{
        
        
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter:'',
        filterOn: [],
        
      }		
	  },
	  watch:{},
      updated() {
      	
      },
	  methods:{
      	
    },
    computed: {
     
    }//computed
  }
</script>

<style lang="scss" scoped>
.column-header{
  background-color:#b8daff;
}
</style>